<template>
  <div class="mb-4 flex flex-col">
    <div class="flex">
      <div class="xvIywb y52p7d hidden md:flex">
        <div class="T6Yut"></div>
        <div class="Vd4i6d"></div>
        <div class="T6Yut"></div>
      </div>
      <div class="flex flex-col">
        <div class="flex">
          <p class="font-black text-black">
            <span>{{ showHour(route.departure_airport.date, route.departure_airport.time) }}</span>
            <span>·</span>
            <span>{{ route.departure_airport.name }} ({{ route.departure_airport.id }})</span>
          </p>
        </div>
        <div class="flex py-2">
          <span>{{ $t('shared.flight_time') }}: {{ showHours(route.duration) }}</span>
          <!-- <overnight v-if="route.overnight">
            Overnight
          </overnight> -->
        </div>
        <div class="flex">
          <p class="font-black text-black">
            <span>{{ showHour(route.departure_airport.date, route.arrival_airport.time) }}</span>
            <span>·</span>
            <span>{{ route.arrival_airport.name }} ({{ route.arrival_airport.id }})</span>
          </p>
        </div>
      </div>
    </div>
    <div>
      <span class="text-xs pt-2">
        {{ route.airline }} · {{ route.travel_class }} · {{ route.airplane }} · {{ route.flight_number }}
      </span>
    </div>
    <div class="flex mt-4 border-y border-solid border-semiDarkgrey py-2" v-if="index < numRoutes - 1">
      <div class="flex">
        <p>
          {{ showHours(layovers[index].duration) }} · {{ layovers[index].name }} ({{ layovers[index].id }})
        </p>
        <!-- <overnight v-if="layovers[index].overnight">
          Overnight layover
        </overnight> -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { minutesToHoursMinutes } from '../helpers';
import Overnight from "./Overnight.vue";

export default {
  components: {
    Overnight
  },
  props: {
    route: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    layovers: {
      type: Array,
      required: true
    },
    numRoutes: {
      type: Number,
      required: true
    }
  },
  methods: {
    showHours(minutes) {
      return minutesToHoursMinutes(minutes)
    },
    showHour(date, time) {
      return moment(date + ' ' + time).format('HH:mm')
    },
  }
}
</script>

<style lang="scss">
.alert-red {
  color: #F28B82;
}
</style>
